import React, { useEffect, useState } from "react";
// // import Icon from "@mdi/react";
// import { mdiAlert, mdiCheckCircle, mdiClose, mdiHelp } from "@mdi/js";
import { Icon } from '@iconify/react/dist/iconify.js';


const ModalAlert = (props) => {
  const {
    show = false,
    type,
    action,
    cancel,
    code,
    status,
    text,
    children,
    message,
    // showIcon = false,
    // confirmIcon = null
  } = props;

  const [isShow, setIsShow] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [icon, setIcon] = useState(<div></div>);
  const [iconColor, setIconColor] = useState('');
  const [borderColor, setBorderColor] = useState('');
  const [textColor, setTextColor] = useState('');

  const modalType = [
    {
      type: "success",
      icon: <Icon icon="mdi:check-circle" width="60" height="60" />,
      iconColor: "text-success",
      borderColor: "border-success",
      textColor: "text-dark",
      headerClass: "bg-[#ffffff] text-black",
      bodyClass: "bg-[#ffffff] text-black",
      footerClass: "bg-[#ffffff] text-black"
    },
    {
      type: "warning",
      icon: <Icon icon="mdi:warning-circle" width="60" height="60" />,
      iconColor: "text-warning",
      borderColor: "border-warning",
      textColor: "text-dark",
      headerClass: "bg-[#ffffff] text-white",
      bodyClass: "bg-[#ffffff] text-black",
      footerClass: "bg-[#ffffff] text-white"
    },
    {
      type: "failed",
      icon: <Icon icon="mdi:close-circle" width="60" height="60"/>,
      iconColor: "text-danger",
      borderColor: "border-danger",
      textColor: "text-danger",
      headerClass: "bg-[#ffffff] text-white",
      bodyClass: "bg-[#ffffff] text-black",
      footerClass: "bg-[#ffffff] text-white"
    },
    {
      type: "confirm",
      icon: <Icon icon="mdi:help-circle" width="60" height="60" />,
      iconColor: "text-dark",
      borderColor: "border-dark",
      textColor: "text-dark",
      headerClass: "bg-[#ffffff]text-white",
      bodyClass: "bg-[#ffffff] text-black",
      footerClass: "bg-[#ffffff] text-white"
    },
  ];

  useEffect(() => {
    console.log('show:', show);
    if (show) {
      setIsShow(true);
    }

    for (const element of modalType) {
      if (type === element.type) {
        setIcon(element.icon);
        setIconColor(element.iconColor);
        setBorderColor(element.borderColor);
        setTextColor(element.textColor);
        if (type === "confirm") {
          setConfirm(true);
        } else {
          setConfirm(false);
        }
      }
    }
  }, [props]);

  function handleOk() {
    console.log('handleOk dipanggil');
    document.getElementById('root').classList.remove('brightness-50');
    if (action) {
      action();
    }
    setIsShow(false);
  }

  function handleCancel() {
    console.log('handleCancel dipanggil');
    document.getElementById('root').classList.remove('brightness-50');
    if (cancel) {
      cancel();
    }
    setIsShow(false);
  }

  return (
    <div
      className={`${
        isShow ? "modal fade show" : "modal fade"
      } transition-opacity duration-300 ease-in-out`}
       style={{ display: isShow ? "block" : "none" }}
    > 
        <div className="modal-dialog modal-dialog-centered">
          <div className={`modal-content shadow-lg`}>
            <div className={`modal-header ${modalType.find((item) => item.type === type).headerClass} border-0`}>
              <h5 className="modal-title" id="exampleModalLabel">
                {status === 401 || status === 403 || status === 500
                  ? "ERROR : "
                  : null}
                {status}
              </h5>
              {/* <button type="button" className="btn-close" onClick={handleCancel}></button> */}
            </div>
            <div className={`modal-body ${modalType.find((item) => item.type === type).bodyClass}`}>
              <div className="d-flex justify-content-center">
                <div className={`rounded-full ${borderColor} p-1 border-opacity-40 ${iconColor}`}>
                  {icon}
                </div>
              </div>
              <p className={`text-center ${textColor}`}>{code}</p>
              <p className={`text-center ${textColor}`}>{text}</p>
              {message && <p className="text-center">{message}</p>}
              {children}
            </div>
            <div className={`modal-footer ${modalType.find((item) => item.type === type).footerClass} border-0 w-100`}>
            {confirm ? (
                <div className="row w-100">
                <div className="col-6 pe-1">
                    <button type="button" className="btn btn-secondary w-100" onClick={handleCancel}>Cancel</button>
                </div>
                <div className="col-6 ps-1">
                    <button type="button" className={`btn ${type === 'confirm' ? 'btn-danger' : 'btn-dark'} w-100`} onClick={handleOk}>Yes</button>
                </div>
                </div>
            ) : (
                <div className="d-grid gap-2 col-6 mx-auto">
                <button type="button" className={`btn ${type === 'failed' ? 'btn-danger' : 'btn-dark'}`} onClick={handleOk}>OK</button>
                </div>
            )}
            </div>
          </div>
        </div>
    </div>
  );
};

export default ModalAlert;